<template>
  <div class="wrap">
    <div class="header-salary-container">
      <div class="label">实发薪资</div>
      <div class="salary">{{ realPay }}</div>
    </div>
    <div class="salary-info-container">
      <van-row>
        <img class="icon-gongzidan" src="../../../assets/gongzidan.svg" alt="" />
        <span class="label">工资详情</span>

        <van-collapse v-model="activeNames">
          <van-collapse-item :title="item.title" :name="index" v-for="(item, index) in list" :key="index">
            <van-row
              class="item"
              type="flex"
              justify="space-between"
              v-for="(item1, index1) in item.children"
              :key="index1"
            >
              <div>{{ item1.describe }}</div>
              <div class="txt-black">{{ item1.salary }}</div>
            </van-row>
          </van-collapse-item>
        </van-collapse>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [""],
      realPay: "￥0.00",
      list: [
        {
          title: "应发工资",
          children: [
            // { describe: "基本工资", salary: "￥40,000.00" },
            // { describe: "加班工资", salary: "￥300.00" },
            // { describe: "绩效", salary: "￥1,666.00" },
            // { describe: "请假", salary: "- ￥200.00" },
          ],
        },
        {
          title: "社保",
          children: [
            // { describe: "工伤保险", salary: "- ￥200.00" },
            // { describe: "医疗保险", salary: "- ￥300.00" },
            // { describe: "养老保险", salary: "- ￥300.00" },
          ],
        },
      ],
    };
  },
  methods: {
    async init() {
      let params = {
        id: this.$route.params.id,
      };
      let { data } = await this.$post(this.$api.stGetSalaryInfo, params);
      this.realPay = data.realPay;
      this.list = data.list;
    },
  },
  mounted() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "工资单详情" });
    });
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #f3f3f3;
}
.header-salary-container {
  box-sizing: border-box;
  padding: 20px 0;
  height: 86px;
  text-align: center;
  background-color: #fff;
}
.label {
  color: #505050;
}
.salary {
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #2a82e4;
}
.salary-info-container {
  min-height: calc(100vh - 126px);
  margin: 10px;
  padding: 10px 8px;
  background-color: #fff;
  border-radius: 5px;

  .label {
    margin-left: 6px;
    font-weight: bold;
    line-height: 26px;
  }
}

.icon-gongzidan {
  width: 26px;
  height: 26px;
  vertical-align: top;
}

.salary-info-title {
  position: relative;
  padding: 8px 0;
}
.salary-info-title:active {
  background: #f3f3f3;
}
.icon-arrow {
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 18px;
}
.icon-arrow.active {
  transform: rotate(-180deg);
}
.van-row .salary-li {
  margin: 8px 0;
  padding: 8px 0;
  border-bottom: 1px dotted #999999;
}
.label + .salary-li {
  border-top: 1px dotted #999999;
}
.van-collapse {
  margin-top: 5px;

  .item {
    margin: 5px 0;
  }
  .txt-black {
    color: #333;
  }
}
</style>
